import React from "react";
import ViewIndicator from "./view-indicator";
import ViewChanger from "./view-changer";
import ExitButton from "./exit-button";
import WatchPreviewImageLayers from "./watch-preview-image-layers";
import { useWatchViewContext } from "../../providers/watch-view-provider";
import { useSwipeable } from "react-swipeable";
import { useSelector } from "react-redux";
import { selectFinishedEditing } from "../../customisation-slice";
import {
  conditionallyAddStyles,
  getPriceFromVariant,
} from "../../support/helpers";
import { useProductVariantContext } from "../../providers/product-variant-provider";
import Loading from "../loading";

const WatchPreviewContainer = () => {
  const { viewIndex, goToNextView, goToPreviousView } = useWatchViewContext();
  const { getCurrentProductVariant, loadingVariants } =
    useProductVariantContext();
  const finishedEditing = useSelector(selectFinishedEditing);

  const swipeHandler = useSwipeable({
    onSwiped: (eventData) => {
      if (eventData.dir === "Left" && viewIndex !== 3) {
        goToNextView();
      } else if (eventData.dir === "Right" && viewIndex !== 0) {
        goToPreviousView();
      }
    },
  });

  const defaultClasses = [
    "flex-grow",
    "flex",
    "flex-col",
    "justify-between",
    "p-4",
    "md:p-8",
  ];

  conditionallyAddStyles(finishedEditing, defaultClasses, "min-h-1/2-screen");

  const getCurrentPrice = () => {
    const currentVariant = getCurrentProductVariant();
    return getPriceFromVariant(currentVariant);
  };

  return (
    <>
      {loadingVariants ? (
        <Loading />
      ) : (
        <div className={defaultClasses.join(" ")}>
          <div className="absolute z-10">
            <ExitButton />
            {!finishedEditing && (
              <div className="hidden md:block">
                <div className="heading-1 mt-6">The Bamford GMT</div>
                <div className="heading-3">{`${getCurrentPrice()} inc VAT`}</div>
              </div>
            )}
          </div>
          <div className="flex flex-grow justify-between" {...swipeHandler}>
            <ViewChanger
              side="left"
              viewIndex={viewIndex}
              onClick={goToPreviousView}
            />
            <WatchPreviewImageLayers viewIndex={viewIndex} />
            <ViewChanger viewIndex={viewIndex} onClick={goToNextView} />
          </div>
          <ViewIndicator viewIndex={viewIndex} />
        </div>
      )}
    </>
  );
};

export default WatchPreviewContainer;
